/**
 * Conversa com o Pilotar/Hyperpay quando o painel roda dentro do iframe dele (/embutido).
 *
 * Trocar a rota do PAI direto não dá: as origens são diferentes, então ler `parent.location` é
 * barrado pela same-origin policy e navegar o topo a partir de um iframe de outra origem depende de
 * gesto do usuário e morre em qualquer `sandbox`. O caminho que funciona é pedir por postMessage e
 * deixar o Hyperpay navegar a si mesmo.
 *
 * O que sai daqui é uma INTENÇÃO, nunca uma rota pronta: quem monta o caminho é o Hyperpay. Se um
 * dia esta tela for comprometida, o máximo que ela consegue é pedir a cobrança errada — não levar o
 * painel inteiro para uma rota escolhida por um atacante.
 */

const ORIGEM_DO_HYPERPAY = import.meta.env.VITE_HYPERPAY_ORIGIN ?? 'https://conta.pilotar.app'

export interface PedidoDePagarCobranca {
  tipo: 'newdriver:pagar-cobranca'
  cobrancaId: string
}

export function pedirParaPagarCobrancaNoHyperpay(cobrancaId: string): void {
  const pedido: PedidoDePagarCobranca = { tipo: 'newdriver:pagar-cobranca', cobrancaId }
  // A origem vai explícita: com '*' o payload chega a qualquer página que nos tenha embutido.
  window.parent.postMessage(pedido, ORIGEM_DO_HYPERPAY)
}
